import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-tech bg-white" data-id="element-81" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-82" data-mp="4lqictyan92g" />
      <div className="h-1 bg-alert" aria-hidden="true" data-id="element-83" data-mp="4n1oh0f7oswq" />
      <div className="mx-auto max-w-5xl px-4 pb-5 pt-3 sm:px-6 sm:pb-7 sm:pt-5" data-id="element-84" data-mp="1297ba1bnev89">
        <h1 className="mx-auto max-w-4xl text-center text-2xl leading-display text-navy sm:text-5xl" data-id="element-85" data-mp="xae9351taqne">
          DIAGNOSTIQUEZ LES PANNES AUTOMOBILES{' '}
          <span className="text-tech" data-id="element-86" data-mp="s9zwrat6gujk">AVEC MÉTHODE, SANS CHANGER DES PIÈCES AU HASARD</span>
        </h1>
        <p className="mx-auto mt-2 max-w-3xl rounded-lg bg-navy px-3 py-1.5 text-center font-display text-sm font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-87" data-mp="nbopn7u9oy51">
          UN CODE DÉFAUT S’AFFICHE…{' '}
          <span className="text-tech-light" data-id="element-88" data-mp="3814aznapvuna">MAIS SAVEZ-VOUS VRAIMENT QUOI VÉRIFIER EN PREMIER ?</span>
        </p>

        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-steel sm:text-base" data-id="element-89" data-mp="3j6fvvj9ob1ao">
          Un système professionnel prêt à l’emploi : fiches techniques, procédures guidées, tableaux
          de diagnostic et outils pratiques pour l’atelier{' '}
          <strong className="font-semibold text-navy" data-id="element-90" data-mp="3e84mf9naissz">
            pour avancer étape par étape : SYMPTÔME › CODES › MESURES › HYPOTHÈSE › VALIDATION.
          </strong>
        </p>

        <MockupImage className="mt-2" priority data-id="element-91" data-mp="359t19n570n7x" />

        <div className="mt-2 flex flex-col items-center" data-id="element-92" data-mp="35akly2x950jf">
          <CTAButton href={OFFER_ANCHOR} data-id="element-93" data-mp="2ql6ampa4891e">🔧 OUI ! JE VEUX LE SYSTÈME COMPLET</CTAButton>
          <TrustLine items={['🛡️ Garantie satisfait ou remboursé de 7 jours', '🔧 Système complet 6 en 1']} data-id="element-94" data-mp="2vjzq2n8yqa47" />
        </div>
      </div>
    </section>;
}